import { OctIconButton } from "@oceantech/oceantech-ui";
import { MouseEvent } from "react";
import { PATIENT_STATUS } from ".";
import { TableCustomCell } from "../../component/table/components/TableCustomCell";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { CustomColumn } from "../../component/table/table-custom/tableCustomeModel";
import { convertToStringWithDelimiter, formatDateTime } from "../../utils/FormatUtils";

export const PATIENT_COLUMNS: CustomColumn<any>[] = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-50px" title="Thao tác" />
		),
		accessor: "action",
		Cell: ({ row: { original }, tableOptions: { onActionButtonClick } }: any) => {
			return (
				<TableCustomCell
					className="min-w-50px"
					data={
						<div className="d-flex justify-content-center">
							<OctIconButton
								variant="edit"
								title="Xem thông tin bệnh nhân"
								onClick={(e: MouseEvent<HTMLButtonElement>) => {
									e.stopPropagation();
									onActionButtonClick(original, "viewPatient");
								}}
							>
								<i className="bi bi-eye text-navy"></i>
							</OctIconButton>
							{/* <OctIconButton
								variant="edit"
								title="Mở hồ sơ bệnh án"
								onClick={(e: MouseEvent<HTMLButtonElement>) => {
									e.stopPropagation();
									onActionButtonClick(original, "viewMedicalRecord");
								}}
							>
								<i className="bi bi-clipboard2-pulse text-navy"></i>
							</OctIconButton> */}
						</div>
					}
				/>
			);
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-40px" title="STT" />
		),
		accessor: "order",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-40px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-200px" title="Họ và tên" />
		),
		accessor: "patientName",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-200px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-100px" title="Mã BN" />
		),
		accessor: "patientCode",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-60px" title="Giới tính" />
		),
		accessor: "gender",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-60px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-80px" title="Ngày sinh" />
		),
		accessor: "textBirthDate",
		Cell: ({ row: { original } }) => {
			return (
				<TableCustomCell
					data={convertToStringWithDelimiter(
						[original?.dobDay, original?.dobMonth, original?.dobYear],
						"/"
					)}
					className="min-w-80px text-center"
				/>
			);
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-80px" title="SĐT" />
		),
		accessor: "phoneNumber",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-80px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-150px" title="Tỉnh/TP" />
		),
		accessor: "province",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-150px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-125px"
				title="Trạng thái KB"
			/>
		),
		accessor: "status",
		Cell: ({ value }) => {
			const displayValue = PATIENT_STATUS.find((item) => item.value === value)?.name ?? "";
			return <TableCustomCell data={displayValue} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-125px"
				title="Trạng thái BA"
			/>
		),
		accessor: "medicalRecordStatus",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px" />;
		},
	},
];

export const MEDICAL_RECORD_COLUMNS: CustomColumn<any>[] = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-75px" title="Thao tác" />
		),
		accessor: "action",
		Cell: ({ row: { original }, tableOptions: { onActionButtonClick } }: any) => {
			return (
				<TableCustomCell
					className="min-w-75px"
					data={
						<div className="d-flex justify-content-center">
							<OctIconButton
								variant="edit"
								title="Xem bệnh án"
								onClick={(e: MouseEvent<HTMLButtonElement>) => {
									e.stopPropagation();
									onActionButtonClick?.(original, "viewMedicalRecord");
								}}
							>
								<i className="bi bi-eye text-navy"></i>
							</OctIconButton>
						</div>
					}
				/>
			);
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-40px" title="STT" />
		),
		accessor: "order",
		Cell: ({ row }) => {
			return <TableCustomCell data={row.index + 1} className="min-w-40px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Trạng thái"
			/>
		),
		accessor: "status",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-125px" title="Mã hồ sơ" />
		),
		accessor: "medicalRecordCode",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-250px"
				title="Loại hồ sơ"
			/>
		),
		accessor: "recordTypeName",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-250px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-80px" title="Năm hồ sơ" />
		),
		accessor: "year",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="text-center min-w-80px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-80px" title="Số chữ ký" />
		),
		accessor: "numberOfSign",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-80px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-125px" title="Ngày tạo" />
		),
		accessor: "createdDate",
		Cell: ({ value }) => {
			return <TableCustomCell data={formatDateTime(value)} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-125px" title="Người tạo" />
		),
		accessor: "createdBy",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-125px"
				title="Ngày cập nhật"
			/>
		),
		accessor: "modifiedDate",
		Cell: ({ value }) => {
			return <TableCustomCell data={formatDateTime(value)} className="min-w-125px" />;
		},
	},
];
